module.exports = __webpack_public_path__ + "static/media/cardIcons.66e21e0d.jpg";